export default {
  namespaced: true,

  state: {
      isLoading: true,
      creatingSecrets: false,
      teamHasNameSpace: true,
      templateIsLoading: true,
      hasData: false,
      hasDetails: false,
      namespaces: [],
      profiles: [],
      extensions: [],
      list: [],
      selected: [],
      projectSecrets: [],
      dnsSecrets: [],
      secrets: [],
      updateKey: 0,
      updateDetailsKey: 0,
      updateKeyForm: 0,
      current: false,
      currentNamespace: false,
      currentAccount: false,
      serviceAccounts: false,
      newServiceAccount: false,
      currentInfo: false,
      versions: false,
      kubernetesVersions: false,
      kubernetesVersionsArray: false,
      projectCreationStatus: false,
      newSecret: false,
      currentSecret: false,
      rotation: false,
      purposes: [
        {
          'name': 'Production',
          'val': 'production'
        },{
          'name': 'Testing',
          'val': 'testing',
          'info': 'Testing clusters do not get a monitoring or a logging stack as part of their control planes'
        },{
          'name': 'Evaluation',
          'val': 'evaluation'
        },
      ],
      managedExtensions: [
        {
          'name': 'DNS Service',
          'val': 'shoot-dns-service',
          'info': 'A way to support external controllers that contain their very own vendor specifics. This way, we can keep EMK core clean and independent.',
          'docs': 'https://docs.cyso.cloud'
        },{
          'name': 'Certificate Service',
          'val': 'shoot-cert-service',
          'info': 'This extension controller relies on the EMK-Resource-Manager to deploy k8s resources to seed and shoot clusters, ie it never deploys them directly.',
          'docs': 'https://docs.cyso.cloud'

        },{
          'name': 'Registry Cache',
          'val': 'registry-cache',
          'info': 'EMK extension controller which deploys pull-through caches for container registries.',
          'docs': 'https://docs.cyso.cloud'
        },
      ]
  },

  mutations: {
    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    CREATING_SECRETS(state, bool) {
      state.creatingSecrets = bool;
    },

    TEAM_HAS_NAMESPACE(state, bool) {
      state.teamHasNameSpace = bool;
    },

    HAS_DATA(state, bool) {
      state.hasData = bool;
    },

    HAS_DETAILS(state, bool) {
      state.hasDetails = bool;
    },

    SET_NAMESPACES(state, services) {
      state.namespaces = services;
    },

    SET_PROFILES(state, services) {
      state.profiles = services;
    },

    SET_EXTENSIONS(state, services) {
      state.extensions = services;
    },

    SET(state, services) {
      state.list = services;
    },

    SET_ACCOUNTS(state, services) {
      state.serviceAccounts = services;
    },

    SET_CURRENT(state, services) {
      state.current = services;
    },

    SET_CURRENT_NAMESPACE(state, services) {
      state.currentNamespace = services;
    },

    SET_CURRENT_SECRET(state, services) {
      state.currentSecret = services;
    },

    SET_NEW_SECRET(state, services) {
      state.newSecret = services;
    },

    SET_NEW_SERVICE_ACCOUNT(state, services) {
      state.newServiceAccount = services;
    },

    SET_CURRENT_ACCOUNT(state, services) {
      state.currentAccount = services;
    },

    SET_CURRENT_INFO(state, services) {
      state.currentInfo = services;
    },

    SET_VERSIONS(state, services) {
      state.versions = services;
    },

    SET_ROTATION(state, services) {
      state.rotation = services;
    },

    SET_KUBERNETES_VERSIONS(state, services) {
        let data = [...services].reverse();
        let arr = []

        data.forEach((item, i) => {
            arr.push(item.version);
        });

        arr = arr.map( a => a.replace(/\d+/g, n => +n+100000 ) ).sort()
        .map( a => a.replace(/\d+/g, n => +n-100000 ) );

        state.kubernetesVersionsArray = arr.reverse();
        state.kubernetesVersions = data;
    },

    SET_PROJECT_SECRETS(state, services) {
      state.projectSecrets = services;
    },

    SET_DNS_SECRETS(state, services) {
      state.dnsSecrets = services;
    },

    SET_SECRETS(state, services) {
      state.secrets = services;
    },

    SET_POLLING_PROJECT(state, bool) {
      state.projectCreationStatus = bool;
    },

    SET_SELECTED(state, resources) {
      state.selected = resources;
    },

    UPDATE(state, resource) {
        const item = state.list.find(item => item.uuid === resource.uuid);
        Object.assign(item, resource);
    },

    UPDATE_CLUSTER(state, resource) {
        const item = state.list.find(item => item.metadata.uid === resource.metadata.uid);
        if (item) {
            Object.assign(item, resource);
        } else {
            Object.assign(state.list, resource);
        }
    },

    REMOVE_CLUSTER(state, resource) {
        let newData = state.list.filter(item => item.metadata.uid !== resource.metadata.uid);
        state.list = newData;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },

    UPDATE_DETAILS_KEY(state) {
      state.updateDetailsKey += 1;
    },

    UPDATE_KEY_FORM(state) {
      state.updateKeyForm += 1;
    },

    ADD_EMK(state, service) {
        // const item = state.list.find(item => item.metadata.name === service.metadata.name);
        // if (!item) {
        //     let newKey = state.list.length + 1;
        //     let oldKey = Object.keys(service);
        //     delete Object.assign(service, {[newKey]: service[oldKey] })[oldKey];
        //
        //     state.list.push(service);
        // }
        state.list.push(service);
    },
  },

  actions: {
    SET(context, services) {
      context.commit('SET', services);
    },

    SET_SELECTED(context, resources) {
      context.commit('SET_SELECTED', resources);
    },
  }
}
